import React, { ReactElement, ReactNode, useState } from "react";
import Head from "next/head";

import Header from "@components/vpnpricecomparison/header";
import { getCookie, setCookie } from "cookies-next";

import styles from "./layouts.module.scss";
import { hexToRGBA } from "@lib/sharedUtils";
import Schema from "@components/scripts/schema";
import dynamic from "next/dynamic";
import { useDomainContext } from "@hooks/useDomainContext";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";
import { useModal } from "@hooks/useModalContext";
const Footer = dynamic(() => import("@components/vpnpricecomparison/footer"));
const CloseIcon = dynamic(() => import("@components/svg/closeIcon"));
const Popup = dynamic(() => import("@components/vpnpricecomparison/popup"), {
    ssr: false,
});
const Modal = dynamic(() => import("@components/shared/modal"), {
    ssr: false,
});

export function VpnPriceComparisonWrapper({
    backgroundColor,
    withFlag,
    children,
}: {
    backgroundColor?: string | undefined;
    withFlag?: boolean;
    children: ReactNode;
}): ReactElement {
    const { modal, closeModal } = useModal();
    const [vpnModalActive, setVpnModalActive] = useState(false);

    const modalActive = vpnModalActive;
    const modalActiveBlogPost = modal.active;

    const handleClose = () => {
        closeModal();
    };
    const { domainPopup } = useDomainContext();

    const handleMouseLeave = () => {
        if (
            document.activeElement?.tagName === "INPUT" ||
            document.activeElement?.tagName === "SELECT"
        )
            return;

        if (!getCookie("popup-shown")) {
            setVpnModalActive(true);
            setCookie("popup-shown", "true");
        }
    };

    const handleModalClose = () => {
        setVpnModalActive(false);
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link
                    rel="preconnect"
                    href="https://fonts.gstatic.com"
                    crossOrigin="true"
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700;800&display=swap"
                    rel="stylesheet"
                />

                <Schema
                    url="https://vpnpricecomparison.com"
                    name="VPN Price Comparison"
                />
            </Head>
            <div
                onMouseLeave={handleMouseLeave}
                style={{
                    fontFamily: `'Poppins', sans-serif`,
                }}
                className={styles["vpnpricecomparison-inner-body"]}
            >
                {backgroundColor && (
                    <span
                        style={{
                            background: `linear-gradient(
                        to bottom,
                        ${hexToRGBA(backgroundColor, 1)} -43%,
                        rgba(206, 48, 48, 0) 48%,
                        rgba(198, 44, 46, 0) 161%
                    )`,
                        }}
                        className={styles["background"]}
                    />
                )}
                <Header withFlag={withFlag} />
                <main className="max-w-7xl mx-auto block px-4vw lg:px-4">
                    {children}
                </main>
                <Footer />
                {domainPopup && (
                    <Modal
                        onClose={handleModalClose}
                        active={modalActive}
                        closeIcon={<CloseIcon />}
                        backdropClosable
                        modalClassName="h-90vh lg:h-500px rounded"
                        wrapperClassName="flex items-center"
                        modalStyles={{ fontFamily: `'Poppins', sans-serif` }}
                        bodyStyles={{ height: "100%" }}
                        width={900}
                    >
                        <Popup data={domainPopup} />
                    </Modal>
                )}
                <Modal
                    onClose={handleClose}
                    active={modalActiveBlogPost}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "80vh",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header="Contents"
                >
                    <Mobile />
                </Modal>
            </div>
        </>
    );
}
